import type { CaregiverApplicationRequest } from "./types/caregiver-application";

import { apiPost } from "@homeinstead/shared/outbound";
import {
  getMarketingApiConfig,
  MARKETING_API_KEY_HEADER,
} from "./get-marketing-api-config";

const CAREGIVER_APPLICATIONS_PATH = "/api/v1/jobs/caregiver-applications";

async function postCaregiverApplication<T>(
  body: CaregiverApplicationRequest,
): Promise<T> {
  const { apiKey, url } = getMarketingApiConfig();

  return apiPost<T>(
    `${url}${CAREGIVER_APPLICATIONS_PATH}`,
    {
      body: JSON.stringify(body),
      headers: {
        [MARKETING_API_KEY_HEADER]: apiKey,
      },
    },
    {},
  );
}

export { postCaregiverApplication };
